import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enum';
import { createButtonLink } from '@vfde-brix/ws10/button-link';

/**
 * Create Brix ButtonLink component.
 *
 * @param id - Wrapper ID of the element.
 * @param onClick - OnClick event.
 * @throws - error if element is not found in DOM
 * @returns ButtonLink
 */
export const mountButtonLink = (id: HtmlId, onClick?: () => void) =>
    createButtonLink(document.getElementById(id)!, onClick
        ? { onClick }
        : NO_PATTERN_BUSINESS_LOGIC,
    );
